var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('v-icon',{key:_vm.$vuetify.theme.dark,on:{"click":function () {
        _vm.saveToLocalStorage(!_vm.$vuetify.theme.dark);
        _vm.$vuetify.theme.dark = !_vm.$vuetify.theme.dark;
      }}},[_vm._v(" "+_vm._s(_vm.$vuetify.theme.dark ? _vm.icons.mdiWeatherSunny : _vm.icons.mdiWeatherNight)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }